import { constRoutes, asyncRoutes } from "@/router";
import router from "@/router";
/* Layout */
import Layout from "@/layout";
import vuex from "@/store";
import { isConsolidatedAiTrainPath, aiTrainLegacyDestination } from '@/utils/ai-train-navigation'

// 导入所有组件
const list = require.context(
  "@/views", // 组件所在的文件夹路径
  true, // 是否在子文件夹中查找
  /\.vue/ // 组件文件的后缀名
);
const vueobj = {};
// 遍历所有组件并注册
list.keys().forEach(fileName => {
  // 获取组件配置
  vueobj[fileName] = list(fileName).default;
});
const state = {
  routes: [], //完整路由表
  addRoutes: [] //用户可访问路由表
};

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes;
    state.routes = (constRoutes || []).concat(routes || []);
  }
};

const actions = {
  // 路由生成：在得到用户角色后第一时间调用
  generateRoutes({ commit }, roles) {
    return new Promise(resolve => {
      // 根据角色做过滤处理
      const accessedRoutes = filterAsyncRoutes(asyncRoutes || [], roles);
      commit("SET_ROUTES", accessedRoutes);
      resolve(accessedRoutes);
    });
  }
};
/**
 * 递归路由表
 */
const dgFn = (list, isOne = true, path = "") => {
  // console.log("path: ",path);
  return list.reduce((arr, item) => {
    // console.log("item.resCode: ",item.componentUr);

    // console.log("'@/views' + path + item.resCode: ",`@/views${path}${item.resCode}`);
    // console.log("isOne: ",isOne);
    // const name = item.resCode.split('/')[item.resCode.split('/').length-1]
    const name = item.resCode ? item.resCode.replaceAll("/", "") : "";
    if (item.resType === 3) return arr;
    if (isConsolidatedAiTrainPath(item.resCode)) {
      arr.push({ path: item.resCode, hidden: true, redirect: aiTrainLegacyDestination });
      return arr;
    }
    // console.log('name:--------------- ',vueobj[`.${item.resCode}/index.vue`]);
    arr.push(
      (!item.children || item.children.length == 0) && isOne
        ? {
            path: item.resCode,
            component: Layout,
            prompt: item.prompt,
            hidden: item.hidden,
            children: [
              {
                path: item.resCode,
                name: item.resName,
                prompt: item.prompt,
                component: getComponentByPath(item.resCode),
                zwq: `./${item.resCode}.vue`,
                meta: {
                  title: item.resName,
                  icon: item.icon,
                  requiresHome: item.resCode === "/home",
                  activeMenu: item.activeMenu ? item.activeMenu : ""
                }
              }
            ]
          }
        : {
            path: item.resCode,
            component: isOne
              ? Layout
              : item.componentUrl
              ? vueobj[`.${item.componentUrl}.vue`]
              : vueobj[`.${item.resCode}/index.vue`],
            meta: {
              title: item.resName,
              icon: item.icon,
              requiresHome: item.resCode === "/home",
              activeMenu: item.activeMenu ? item.activeMenu : ""
            },

            hidden: item.hidden,
            children:
              item.children &&
              dgFn(
                Object.values(
                  item.children.reduce(
                    (obj, v) => ({
                      ...obj,
                      [v.resCode]: v
                    }),
                    {}
                  )
                ),
                false,
                `/${name}`
              ),
            prompt: item.prompt
            // children: item.children && dgFn(item.children.filter(v => v.resCode == "index"), false, `/${name}`),
          }
    );
    return arr;
  }, []);
};

//检查不是 index.vue 结尾 文件
const getComponentByPath = path => {
  if (path === "/home") return vueobj["./_home/index.vue"];
  let component = vueobj[`.${path}/index.vue`];
  if (!component) {
    component = vueobj[`.${path}.vue`];
  }
  if (component) return component;
  return null;
};
/**
 * 递归过滤AsyncRoutes路由表
 * @routes 带过滤的路由表，首次传入的就是AsyncRoutes
 * @roles  用户拥有角色
 */
let routesList = []; // 保存路由
export function filterAsyncRoutes(routes = [], e) {
  routesList = dgFn((routes || []).filter(v => v.resCode != "/home1"));
  localStorage.setItem("routes", JSON.stringify(routesList || []));
  const keys = [];

  // 避免重复添加路由，先检查是否已存在
  try {
    router.addRoutes(routesList);
  } catch (error) {
    console.warn("路由添加失败，可能存在重复路由:", error);
  }

  window.zwq = routesList;
  vuex.commit("user/SET_ROUTE", routesList);
  return routesList;
}
/**
 * 递归移除
 * @param {Object} list 路由数据
 */
function ResetRoute(list) {
  list.forEach(v => {
    router.removeRoute(v.name);
    Array.isArray(v.children) && ResetRoute(v.children);
  });
}
/**
 * 删除/重置路由
 */
export function frontEndsResetRoute() {
  // ResetRoute(routesList)
}

/**
 * 根据路由meta.role确定是否当前用户拥有访问权限
 * @roles 用户拥有的角色
 * @route 待判定路由
 */

export function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    //  若用户拥有的角色中有被包含在待判定的路由角色表中则拥有访问权
    return roles.some(role => route.meta.roles.includes(role));
  } else {
    //  没有设置roles则无需判定即可访问
    return true;
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
